import React, { useEffect, useState } from 'react'
import './InputFormCe.scss'

interface InputProps{
    placeholderInput: string;
    labelInput?: string;
    maxLenghtInput: number;
    valueInserted?:string|number;
    idInput: string;
    typeInput: "text" | "password" | "number" | "email" | "text-area";
    helpText?: string;
    nameInput: string;
    onChange?: (event:any)=>void;
    onFocus?: (event:any)=>void;
    onPaste?: (event:any)=>void;
    onBlur?: (event:any)=>void;
    errorText?: string;
    isValid?:boolean;
    disabledInput?:boolean;
    readOnlyInput?:boolean;
    required:boolean;
    refInput?: any;
    styleCustomize?:string;
}

const InputFormCe = ({
    placeholderInput,
    labelInput,
    idInput,
    typeInput,
    maxLenghtInput,
    valueInserted,
    helpText,
    nameInput,
    onChange,
    onFocus,
    errorText,
    isValid,
    onPaste,
    onBlur,
    disabledInput,
    readOnlyInput,
    required,
    refInput,
    styleCustomize,
    ...props
}: InputProps) => {

    const [stateShowPd] = useState(false);
    const [typeInputPd, setStateTypeInputPd] = useState(typeInput);

    useEffect(() => {
        if (stateShowPd) {
            setStateTypeInputPd("text");
        }else{
            setStateTypeInputPd("password");
        }
    }, [stateShowPd])
    
  return (
    <div className={`ce-als-input ${styleCustomize}`}>
        {labelInput !== "" ?
        <label className='' htmlFor={idInput}>
            {labelInput} {required ? '*':''} <span className=''>{helpText}</span> 
        </label>:
        null
        }
        <div>
            
            {   
                typeInput === "text-area"? 
                <textarea
                    className={`${((isValid=== false) && errorText) ? 'ce-als-input--error' : ''}`}
                    id={idInput}
                    placeholder={placeholderInput}
                    maxLength={maxLenghtInput}
                    value={valueInserted}
                    onChange={onChange}
                    onFocus={onFocus}
                    name={nameInput}
                    onBlur={onBlur}
                />
                : 
                <input
                    className={`${((isValid=== false) && errorText) ? 'ce-als-input--error' : ''} ${disabledInput=== true? 'ce-als-input--disabled' : ''}`}
                    id={idInput}
                    type={typeInput === "password"? typeInputPd:typeInput}
                    placeholder={placeholderInput}
                    maxLength={maxLenghtInput}
                    value={valueInserted}
                    onChange={onChange}
                    onFocus={onFocus}
                    onPaste={onPaste}
                    name={nameInput}
                    disabled={disabledInput}
                    readOnly={readOnlyInput}
                    onBlur={onBlur}
                    ref={refInput}
                    aria-describedby={`ce-input-error-${idInput}`}
                    aria-required={required}
                    aria-invalid={!isValid}
                />
            }
        </div>
        {((isValid=== false) && errorText)?
        <div role="alert" aria-live="assertive" className='ce-als-input__error-msg' id={`ce-input-error-${idInput}`}>
            <p className=''>* {errorText}</p>
        </div>
        :<></>
        }
        
    </div>
  )
}

export default InputFormCe